import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';
import { ExpandIcon } from 'ui/base/ExpandAllTable/ExpandIcon';

const headerRowStyle = css`
  will-change: transform;
`;

const bodyRowStyle = css`
  will-change: transform;

  &.error-warn {
    &,
    & > td,
    &:hover > td {
      background-color: ${colors['@error-color-light']} !important;
    }
  }

  /* The three rules the styled Table carried. Dropping the odd one left its cells transparent, which
     a sticky column needs to be opaque to occlude the content scrolling under it; dropping the hover
     one left the tables with no row feedback at all. The stripe has to stay !important because the
     zebra class outranks antd's own hover rule either way, so the hover is restated after it. */
  &.odd > td {
    background-color: ${colors['@white']};
  }

  &.even > td {
    background-color: ${colors['@body-bg']} !important;
  }

  &:hover > td {
    background-color: ${colors['@grey-background']} !important;
  }

  &.selectable {
    cursor: pointer;

    > td:last-child {
      cursor: default;
    }
  }
`;

const rootStyle = css`
  padding-bottom: 1px;

  tr.ant-table-expanded-row > td {
    padding-left: 64px;
  }

  td span {
    font-size: 13px;
  }

  &.custom-expand .ant-table-row-level-0 > td.ant-table-row-expand-icon-cell:first-child {
    padding: 0 !important;

    > i[class*='fb-icon'] {
      padding: 16px;
    }
  }
`;

const tableConfig: ConfigProviderProps['table'] = {
  classNames: {
    root: rootStyle,
    header: { row: headerRowStyle },
    body: { row: bodyRowStyle },
  },
  expandable: {
    expandIcon: ExpandIcon,
  },
};

export default tableConfig;
